<template>
  <div>
    <vue-headful title="Logo aanpassen" />
    <Header page_title="Logo aanpassen" />
    <div class="container-fluid app-body">
      <form
        method="post"
        enctype="multipart/form-data"
        @change="onFormChange"
        @submit.prevent="onSubmit"
      >
        <NotificationContainer />
        <input type="hidden" name="source_loc" value="composer_feed" />
        <div>
          <div class="sd-title mini mb-20px right-line">
            <span class="title-text"><svg-icon icon="camera" /> Profielfoto</span>
          </div>
          <div class="card upload bg-gray sd-container small-radius border-0 mb-3">
            <div v-if="user.avatar" class="image_background" :style="this.avatarBackground()"></div>
            <div v-if="preview" class="image_background" :style="this.ImageBackground(preview)"></div>
            <div class="card-body absolute-center" v-if="!user.avatar && !preview">
              <div
                class="d-block avatar rounded-circle position-relative overflow-hidden mx-auto mb-2"
              >
                <div class="icon-wrapper text-center">
                  <i class="material-icons-round">photo_camera</i>
                </div>
              </div>
            </div>
            <input type="file" accept="image/*" ref="file" @change="onFileChange" class="placeholder" />
          </div>
          <div v-if="preview" class="text small text-danger mb-2">
            <small>
              Klik op
              <strong>'bewaar'</strong> om de wijzigingen op te slaan.
            </small>
          </div>
          <button
            type="submit"
            class="btn btn-warning btn-block"
            v-ripple="'rgba(255, 255, 255, 0.35)'"
          >Bewaar</button>
        </div>
      </form>
    </div>
    <Footer />
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      user: "",
      form: {
        avatar: "",
        about: ""
      },
      preview: "",
      required: ""
    };
  },
  async created() {},
  watch: {
    $route: "fetchData"
  },
  async mounted() {
    await this.fetchData();
  },
  methods: {
    async fetchData() {
      this.$store.state.loading = true;
      this.user = JSON.parse(localStorage.getItem("user"));
      this.required = ["about"];
      // update the form obj from user
      for (var obj in this.form) {
        if (this.user[obj]) {
          this.form[obj] = this.user[obj];
        }
      }
      await this.autoFillForm();
      this.$store.state.loading = false;
    },
    async autoFillForm() {
      return new Promise(resolve => {
        if (localStorage.getItem("company-profile")) {
          // other profile details NOT YET saved
          const profile = JSON.parse(localStorage.getItem("company-profile"));
          for (var obj in profile) {
            if (profile[obj]) {
              this.form[obj] = profile[obj]; // update
            }
          }
          this.onFormChange();
        }
        resolve();
      });
    },
    async updateUser() {
      return new Promise(resolve => {
        var user_token = JSON.parse(localStorage.getItem("user-token"));
        let formData = new FormData();
        for (var obj in this.form) {
          formData.append(obj, this.form[obj]);
        }
        // console.log(formData);
        if (user_token && formData) {
          this.$http
            .post(this.$apiURI + "/company", formData, {
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                Authorization: "Bearer " + user_token,
                Accept: "application/json"
              }
            })
            .then(() => {
              // console.log(success);
              const notification = {
                type: "success",
                message: "Je hebt je gegevens succesvol aangepast. "
              };
              this.$store.dispatch("notification/replace", notification, {
                root: true
              });
              resolve();
            })
            .catch(() => {
              // console.log(error);
              const notification = {
                type: "danger",
                message: "Er is een fout opgetreden.",
                  error: true
              };
              this.$store.dispatch("notification/replace", notification, {
                root: true
              });
              this.$store.state.loading = false;
            });
        }
      });
    },
    async onSubmit() {
      this.$store.state.loading = true;
      await this.updateUser();
      await this.updateLocalUser();
      localStorage.removeItem("form-pending");
      this.user = JSON.parse(localStorage.getItem("user"));
      this.preview = "";
      this.$store.state.loading = false;
      window.scrollTo(0, 0);
      this.$router.replace({
        name: "company-dashboard"
      });
    },
    imageLoadError() {
      this.user.avatar = "";
      this.form.avatar = "";
    },
    onFileChange() {
      this.form.avatar = this.$refs.file.files[0];
      // this.preview = URL.createObjectURL(this.form.avatar);
      //   auto submit upload pic
      if (this.$refs.file.files[0]) {
        var reader = new FileReader();
        var _this = this;
        reader.onload = function(e) {
          _this.preview = e.target.result;
        };

        reader.readAsDataURL(this.$refs.file.files[0]);
      }
      this.$store.state.loading = true;
      this.updateUser()
        .then(() => {
          this.updateLocalUser()
            .then(user => {
              this.user = user;
              this.$store.state.user_avatar = user.avatar;
              this.$store.state.loading = false;
              localStorage.removeItem("form-pending");
            })
            .catch(() => {
              this.$store.state.loading = false;
              localStorage.removeItem("form-pending");
              this.preview = "";
            });
        })
        .catch(() => {
          this.$store.state.loading = false;
          localStorage.removeItem("form-pending");
          this.preview = "";
        });
    },
    onFormChange() {
      localStorage.setItem("company-profile", JSON.stringify(this.form));
      localStorage.setItem("form-pending", JSON.stringify(true));
    }
  }
};
</script>

<style scoped>
.upload {
  height: 180px;
}
.image_background {
  border: 1px solid #f5f4f4;
}
@media only screen and (min-device-width: 768px) {
  .image_background {
    background-size: contain;
  }
}
.avatar {
  background: none;
  border-width: 5px;
}
.avatar .icon-wrapper {
  width: 94px;
  height: 94px;
}
.avatar .icon-wrapper i {
  color: #c0bdbb;
}
</style>
